import { HOTPADS_COMSCORE_WINDOW_PARAMS_KEY } from './constants';
import { getHotpadsComscoreParams, type HotpadsComscoreParams, type HotpadsComscoreUserState } from './params';

type HotpadsComscoreWindow = Window & {
  [HOTPADS_COMSCORE_WINDOW_PARAMS_KEY]?: HotpadsComscoreParams;
};

export function setHotpadsComscoreWindowParams(userState: HotpadsComscoreUserState) {
  if (typeof window === 'undefined') return;

  (window as HotpadsComscoreWindow)[HOTPADS_COMSCORE_WINDOW_PARAMS_KEY] = getHotpadsComscoreParams(userState);
}

/**
 * The ZG user token (anonymous or logged in) for this request. These params are
 * the only client-side copy of it: the root layout inlines them in `<head>` and
 * `HydrateInitialUser` refreshes them after a client-side auth read.
 */
export function getHotpadsUserToken(): string {
  if (typeof window === 'undefined') return '';

  return (window as HotpadsComscoreWindow)[HOTPADS_COMSCORE_WINDOW_PARAMS_KEY]?.cs_fpid ?? '';
}
